module.exports = __webpack_public_path__ + "img/logo.2b7c4994.svg";